import React, { useEffect, useState } from 'react';
import './volunteerForm.scss';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useLocalizedNavigate from "../../hooks/useLocalizedNavigate";
import { useTranslation } from 'react-i18next';

const VolunteerForm = () => {
    const { t } = useTranslation();

    const [modalTitle, setModalTitle] = React.useState('');
    const [modalMessage, setModalMessage] = React.useState('');
    const [checked, setChecked] = React.useState(true);
    const [data, setData] = React.useState({});
    const [state, setState] = React.useState([]);
    const [stateSelected, setStateSelected] = React.useState(null);
    const [cities, setCities] = React.useState([]);
    const [citySelected, setCitySelected] = React.useState(null);
    const [zipCodes, setZipCodes] = React.useState([]);
    const [zipCodeSelected, setZipCodeSelected] = React.useState(null);
    const [validated, setValidated] = useState(false);
    const [value, setValue] = React.useState('No');
    const [errorCheck, setErrorCheck] = React.useState(false);

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };
    const navigate = useLocalizedNavigate();
    const [age, setAge] = React.useState('');

    const handleChangeS = (event) => {
        setAge(event.target.value);
    };

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        if (errorCheck === false) {
            navigate("/");
        }
    };

    const submitFormData = (event) => {
        const form = event.currentTarget;
        console.log('form', form.checkValidity());
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setModalTitle(t('volForm.reviewInfo'))
            setModalMessage(t('volForm.fieldsIncorrect'))
            setErrorCheck(true);
            handleClickOpen();
            setValidated(true);
        } else {
            event.preventDefault();
            const data = {}
            for (let i = 0; i < event.target.length; i++) {
                if (event.target[i].name != "" && event.target[i].value != "") {
                    data[event.target[i].name] = event.target[i].value;
                }
                // { [atribute]: event.target.value }
            }
            // event.target[0].name
            // event.target.length
            // event.target[0].value
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = JSON.stringify({
                "ComunityHours": "yes",
                "Email": data.Email,
                "FirstName": data.FirstName,
                "LastName": data.LastName,
                "Password": data.Password,
                "PhisicalAddresses.City": data.City,
                "PhisicalAddresses.State": data.State,
                "PhisicalAddresses.Street": data.Street,
                "PhisicalAddresses.Zipcode": data.Zipcode,
                "PhoneNumber": data.PhoneNumber,
                "Talents": data.Talents,
            });
            console.log("raw", raw);
            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch("https://tc.svdpguadalupe.org/svdp/Voluntiers?webmode=yes", requestOptions)
                // .then(response => response.text())
                // .then(result => console.log(result))
                // .catch(error => console.log('error', error));
                .then(response => response.json())
                .then(result => {
                    console.log('result', result);
                    if (result.success == true) {
                        setModalTitle('')
                        setModalMessage(t('volForm.confirmEmail'))
                        setErrorCheck(false);
                        handleClickOpen();
                    } else {
                        setModalTitle(t('volForm.errorTitle'))
                        setModalMessage(t('volForm.errorInternal'))
                        setErrorCheck(true);
                        handleClickOpen();
                    }
                })
                .catch(error => {
                    console.log('error post', error)
                    setModalTitle(t('volForm.errorTitle'))
                    setModalMessage(t('volForm.errorRegistration'))
                    setErrorCheck(true);
                    handleClickOpen();
                });

        }

    }

    const getState = () => {
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
        fetch("https://tc.svdpguadalupe.org/svdp/Get_US_states", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success == true) {
                    setState(result.data)
                } else {
                    setModalTitle(t('volForm.errorTitle'))
                    setModalMessage(t('volForm.errorInternal'))
                    setErrorCheck(true);
                    handleClickOpen();
                }

            })
            .catch(error => console.log('error', error));
    }

    const getStateValue = (event) => {
        console.log('entre en getStateValue', event);
        if (event.target.value != null || event.target.value != undefined) {
            setStateSelected(event.target.value);
            setCitySelected('');
            setCities([]);
            setZipCodes([]);
            var requestOptions = {
                method: 'GET',
                redirect: 'follow'
            };

            fetch(`https://tc.svdpguadalupe.org/svdp/Get_US_cities_by_state?state=${event.target.value}`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.success == true) {
                        setCities(result.data)
                    } else {
                        setModalTitle(t('volForm.errorTitle'))
                        setModalMessage(t('volForm.errorInternal'))
                        setErrorCheck(true);
                        handleClickOpen();
                    }
                })
                .catch(error => console.log('error', error));
        }
        console.log('state', stateSelected)

    }

    const getCityValue = (event) => {
        console.log('event.target.value', event.target.value)
        if (event.target.value != null || event.target.value != undefined) {
            setCitySelected(event.target.value);
            var requestOptions = {
                method: 'GET',
                redirect: 'follow'
            };
            fetch(`https://tc.svdpguadalupe.org/svdp/Get_US_zipCodes_by_state_city?state=${stateSelected}&city=${event.target.value}`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.success == true) {
                        setZipCodes(result.data)
                    } else {
                        setModalTitle(t('volForm.errorTitle'))
                        setModalMessage(t('volForm.errorInternal'))
                        setErrorCheck(true);
                        handleClickOpen();
                    }
                })
                .catch(error => console.log('error', error));
        }

    }

    const getZipcodeValue = (event) => {
        setZipCodeSelected(event.target.value);
        console.log('zipCode', event.target.value)
    }

    useEffect(() => {
        getState();
        window.scrollTo(0, 0)
    }, []);

    const handleRadioChange = (event) => {
        setValue(event.target.value);
    };

    return (
        <>
            <div className="container">
                <div>
                    <h2>{t('volForm.title')}</h2>
                    <p><strong>{t('volForm.pleaseComplete')}</strong></p>
                    <p>{t('volForm.afterRegister')}</p>
                    <p><kbd>{t('volForm.doNotCome')}</kbd></p>
                    <p>{t('volForm.thanks')}</p>
                    <hr />

                    <Form noValidate validated={validated} onSubmit={submitFormData}>
                        <Row className="mb-3">
                            <Form.Group as={Col} md="12" controlId="validationCustom01">
                                <Form.Label >{t('volForm.volunteerFirstName')}</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    pattern="^[a-zA-Z]+$"
                                    class="form-control"
                                    placeholder={t('volForm.firstName')}
                                    name="FirstName"
                                />
                                <Form.Control.Feedback type="invalid">{t('volForm.invalidData')}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="12" controlId="validationCustom02">
                                <Form.Label class="mt-3">{t('volForm.volunteerLastName')}</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    pattern="^[a-zA-Z]+$"
                                    class="form-control"
                                    placeholder={t('volForm.lastName')}
                                    name="LastName"
                                />
                                <Form.Control.Feedback type="invalid">{t('volForm.invalidData')}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="12" controlId="validationCustom03">
                                <Form.Label class="mt-3">{t('volForm.phoneNumber')}</Form.Label>
                                <Form.Control
                                    required
                                    type="number"
                                    max="9999999999"
                                    class="form-control"
                                    placeholder={t('volForm.phonePlaceholder')}
                                    name="PhoneNumber"
                                />
                                <Form.Control.Feedback type="invalid">{t('volForm.invalidData')}</Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} md="12" controlId="validationCustom05">
                                <Form.Label class="mt-3">{t('volForm.emailLabel')}</Form.Label>
                                <Form.Control
                                    required
                                    type="email"
                                    class="form-control"
                                    placeholder={t('volForm.emailPlaceholder')}
                                    name="Email"
                                />
                                <Form.Control.Feedback type="invalid">{t('volForm.invalidEmail')}</Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} md="12" controlId="validationCustom06" >
                                <Form.Label class="mt-3">{t('volForm.password')}</Form.Label>
                                <Form.Control
                                    required
                                    type="password"
                                    class="form-control"
                                    placeholder={t('volForm.passwordPlaceholder')}
                                    name="Password"
                                />
                                <Form.Control.Feedback type="invalid">{t('volForm.invalidData')}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="12" controlId="validationCustom07">
                                <Form.Label class="mt-3">{t('volForm.address')}</Form.Label>
                                <Form.Select
                                    type="text"
                                    name="State"
                                    id="state"
                                    placeholder="Estado"
                                    class="form-control"
                                    required
                                    onChange={(event) => {
                                        getStateValue(event);
                                    }} >
                                    <option>{t('volForm.selectStateCity')}</option>
                                    {(state ?? []).map(s => (<option value={s}>{s}</option>))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    {t('volForm.selectState')}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="12 pt-1" controlId="validationCustom08">
                                <Form.Select
                                    type="text"
                                    name="City"
                                    id="city"
                                    placeholder="Ciudad"
                                    class="form-control"
                                    required
                                    onChange={(event) => {
                                        getCityValue(event);
                                    }} >
                                    {(cities ?? []).map(s => (<option value={s}>{s}</option>))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    {t('volForm.selectCity')}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="12 pt-1" controlId="validationCustom09" >
                                <Form.Control
                                    required
                                    type="text"
                                    class="form-control"
                                    placeholder={t('volForm.street')}
                                    name="Street"
                                />
                                <Form.Control.Feedback type="invalid">{t('volForm.requiredField')}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="12 pt-1" controlId="validationCustom10">
                                <Form.Select
                                    type="text"
                                    name="Zipcode"
                                    id="zipCode"
                                    class="form-control"
                                    required
                                    onChange={(event) => {
                                        getZipcodeValue(event);
                                    }} >
                                    {(zipCodes ?? []).map(s => (<option value={s}>{s}</option>))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    {t('volForm.selectCity')}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <div class="form-group pt-2">
                                <label for="profesion">{t('volForm.talents')}</label>
                                <textarea class="form-control" rows="5" id="comment" name="Talents"></textarea>
                            </div>
                            <label for="trabajo">{t('volForm.communityHours')}</label>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={value}
                                onChange={handleRadioChange}
                            >
                                <FormControlLabel value="Yes" control={<Radio />} label={t('volForm.yes')} />
                                <FormControlLabel value="No" control={<Radio />} label={t('volForm.no')} />
                            </RadioGroup>
                        </Row>
                        <Button type="submit">{t('volForm.submit')}</Button>

                    </Form>




                    {/* <form onSubmit={submitFormData}>
                        <h3>Información personal</h3>
                        <div class="form-group">
                            <label for="nombre">Nombre del Voluntario:</label>
                            <input pattern="^[a-zA-Z]+$" type="text" class="form-control" placeholder="Nombre" name="FirstName" />
                        </div>
                        <div class="form-group">
                            <label for="apellido">Apellido del Voluntario:</label>
                            <input type="text" class="form-control" placeholder="Apellido" name="LastName" />
                        </div>
                        <div class="form-group">
                            <label for="direccion">Número de teléfono:</label>
                            <input type="number" class="form-control" placeholder="Número telefónico" name="PhoneNumber" />
                        </div>
                        <div class="form-group">
                            <label for="email">Email:  (deberá validar su dirección de mail con un correo que le enviaremos) </label>
                            <input type="email" class="form-control" placeholder="Enter email" name="Email" />
                        </div>
                        <div class="form-group">
                            <label for="pwd">Password:</label>
                            <input type="password" class="form-control" placeholder="Enter password" name="Password" />
                        </div>
                        <div class="form-group">
                            <label for="direccion">Dirección:</label>
                            <select name="State" id="state" placeholder="Estado" class="form-control"
                                onChange={(event) => {
                                    getStateValue(event);
                                }}><option selected>Seleccione su Estado</option>
                                {state.map(s => (<option value={s}>{s}</option>))}
                            </select>

                        </div>
                        <div class="form-group pt-2" >
                            <select class="form-control" placeholder="Ciudad" name="City" id="city" onChange={(event) => {
                                getCityValue(event);
                            }}><option selected>Seleccione su Ciudad</option>
                                {cities.map(s => (<option value={s}>{s}</option>))}
                            </select>
                        </div>
                        <div class="form-group pt-2">
                            <input type="text" class="form-control" placeholder="Calle" name="Street" />
                        </div>
                        <div class="form-group pt-2">
                            <select class="form-control" name="Zipcode" id="zipCode" onChange={(event) => {
                                getZipcodeValue(event);
                            }}><option selected>Seleccione su Código Postal</option>
                                {zipCodes.map(s => (<option value={s}>{s}</option>))}
                            </select>
                        </div>
                        <div class="form-group pt-2">
                            <label for="profesion">Talentos</label>
                            <textarea class="form-control" rows="5" id="comment" name="Talents"></textarea>
                        </div>
                        <div class="form-group">
                            <label for="trabajo">{t('volForm.communityHours')}</label>
                            <div class="radio">
                                <label><input type="radio" name="ComunityHours" />Si</label>
                            </div>
                            <div class="radio">
                                <label><input type="radio" name="ComunityHours" />No</label>
                            </div>
                        </div>
                        <hr />
                        <button type="submit" class="btn btn-lg btn-block btn-primary">Enviar</button>
                        <hr />
                    </form> */}
                </div>
            </div>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {modalTitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {modalMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Ok</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default VolunteerForm;

